import React from 'react';
import { composeParsers, parseOnlyDigits, parseLengthLimit } from '../../../utils/formFieldParsers';
import { composeValidators, required, minDigits } from '../../../utils/formFieldValidators';
import { TextField } from '../../01_atoms/FormElements';
import PopupLink from '../PopupLink';

import programmeStyles from '../../03_organisms/BodyBlocks/BBProgramme/index.module.scss';
import styles from './index.module.scss';
import formattedTextStyles from '../../01_atoms/FormattedText/index.module.scss';

// TODO: Move to donation form settings in https://www.pivotaltracker.com/story/show/165503378
const LegalCopy = () => (
  <>
    <h2>Direct Debit Guarantee</h2>
    <img
      src="/static/images/directdebit-uk.jpg"
      alt="Direct Debit"
      style={{ float: 'right' }}
      width={193}
      height={64}
    />
    <p>
      <strong>
        Concern Worldwide (UK)
        <br />
        The Foundry,
        <br />
        17 Oval Way,
        <br />
        London,
        <br />
        SE11 5RR
      </strong>
    </p>
    <p>
      Originato’s ID:414058
      <br />
      Instruction to your bank or building society to pay by Direct Debit
      <br />
      In order to set up a Direct Debit Instruction online, the account must be in your name and you
      must be the only signatory required to authorise debits from this account. The Direct Debit
      may not be lodged within 10 working days but will be lodged before the first collection, which
      will be the first of the month.
    </p>
    <p>
      All the normal Direct Debit safeguards and guarantees apply. No changes to the amount, date or
      frequency to be debited can be made without notifying you at least 10 working days in advance
      of your account being debited. In the event of any error, you are entitled to an immediate
      refund from your Bank or Building Society. You have the right to cancel a Direct Debit
      instruction at any time by writing to your bank or building society, with a copy to us.
    </p>
    <p>
      <strong>
        Please note that some banks and building societies may not accept Direct Debit instructions
        for some types of account.
      </strong>
    </p>
  </>
);

const sortCodeLabel = 'Branch sort code';

const DonationDirectDebitUK = () => (
  <>
    <TextField
      name="payment_options.account_name"
      label="Name"
      validate={required('Please enter your account name in order to proceed')}
    />

    <div className={`${styles['sort-code']} field field-type-text field-style-normal`}>
      <label htmlFor="payment_options.sort_code.0">
        {sortCodeLabel}
        <span className="validation"> (required)</span>
      </label>
      <div className={styles['sort-code__inline']}>
        <div>
          <TextField
            name="payment_options.sort_code.0"
            parse={composeParsers(parseOnlyDigits, parseLengthLimit(2))}
            validate={composeValidators(required(), minDigits(2))}
            isRequired
            inputMode="numeric"
            pattern="[0-9]+"
            infoOnPatternNotMatched="Please use numbers only"
          />
        </div>
        <div className={styles['sort-code__inline-separator']}>-</div>
        <div>
          <TextField
            name="payment_options.sort_code.1"
            parse={composeParsers(parseOnlyDigits, parseLengthLimit(2))}
            validate={composeValidators(required(), minDigits(2))}
            isRequired
            inputMode="numeric"
            pattern="[0-9]+"
            infoOnPatternNotMatched="Please use numbers only"
          />
        </div>
        <div className={styles['sort-code__inline-separator']}>-</div>
        <div>
          <TextField
            name="payment_options.sort_code.2"
            parse={composeParsers(parseOnlyDigits, parseLengthLimit(2))}
            validate={composeValidators(required(), minDigits(2))}
            isRequired
            inputMode="numeric"
            pattern="[0-9]+"
            infoOnPatternNotMatched="Please use numbers only"
          />
        </div>
      </div>
    </div>

    <div className={styles['account-number']}>
      <TextField
        name="payment_options.account_number"
        label="Bank account number"
        parse={composeParsers(parseOnlyDigits, parseLengthLimit(8))}
        validate={composeValidators(
          required('Please enter your bank account number'),
          minDigits(8),
        )}
        isRequired
        inputMode="numeric"
        pattern="[0-9]+"
        infoOnPatternNotMatched="Please use numbers only"
      />
    </div>

    <p className={`${styles['small-description']} ${formattedTextStyles['formatted-text']}`}>
      <PopupLink className={programmeStyles['popup-programme']} linkText="Direct debit guarantee">
        <LegalCopy />
      </PopupLink>
    </p>

    <div className="hr" />
  </>
);

export default DonationDirectDebitUK;
